import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {map, switchMap} from 'rxjs';
import * as fromGraphql from "./approval-flow-stages.graphql";
import * as fromActions from "./approval-flow-stages.actions";
import {
  createApprovalFlowStageSuccessorMutation,
  removeApprovalFlowStageSuccessorMutation
} from "./approval-flow-stages.actions";

@Injectable()
export class ApprovalFlowStagesEffects {

  createApprovalFlowStagesMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createApprovalFlowStagesMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_APPROVAL_STAGES,
        variables: {
          stage: action?.stage,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertApprovalFlowStages({ approvalFlowStages: result?.data }));
              this.notificationService.successMessage('Created Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateApprovalFlowStagesMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateApprovalFlowStagesMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_APPROVAL_STAGES,
        variables: {
          stage: action?.stage,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertApprovalFlowStages({ approvalFlowStages: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  createSuccessor$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createApprovalFlowStageSuccessorMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_APPROVAL_FLOW_SUCCESSOR,
        variables: {
          successor: action?.successor,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertApprovalFlowStages({ approvalFlowStages: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  removeSuccessor$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeApprovalFlowStageSuccessorMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_APPROVAL_FLOW_SUCCESSOR,
        variables: {
          successorUniqueId: action?.successorUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertApprovalFlowStages({ approvalFlowStages: result?.data }));
              this.notificationService.successMessage('Removed Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  // updateSuccessor$ = createEffect(() => this.actions$.pipe(
  //   ofType(fromActions.createApprovalFlowStageSuccessorMutation),
  //   switchMap((action) => {
  //     return this.apollo.mutate({
  //       mutation: fromGraphql.UPDATE_APPROVAL_FLOW_SUCCESSOR,
  //       variables: {
  //         successor: action?.successor,
  //       }
  //     }).pipe(
  //       this.notificationService.catchError('Problem occurred while updating record'),
  //       map(({ data }: any) => {
  //         if (data) {
  //           const result: any = Object.values(data)[0];
  //           if (result?.response?.code == '9000') {
  //             this.store.dispatch(fromActions.upsertApprovalFlowStages({ approvalFlowStages: result?.data }));
  //             this.notificationService.successMessage('Updated Successfully ');
  //           } else {
  //             this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
  //           }
  //         }
  //       })
  //     );
  //   })
  // ), { dispatch: false });

  removeApprovalFlowStagesMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeApprovalFlowStagesMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_APPROVAL_STAGES,
        variables: {
          stageUniqueId: action?.stageUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteApprovalFlowStages({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getApprovalFlowStages$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getApprovalFlowStages),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_APPROVAL_FLOW_STAGES,
        fetchPolicy: 'network-only',
        variables:{
          flowUniqueId:action?.flowUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service categories'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadApprovalFlowStagess({ approvalFlowStagess: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });



  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
